var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    fill: "none",
    className: "arrow_svg__fill-new-beginnings-base",
    viewBox: "0 0 8 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.066 5.429a1 1 0 0 1 0-1.6L5.9.201a1 1 0 0 1 1.6.8v7.256a1 1 0 0 1-1.6.8z"
  })));
};
export default SvgArrow;